import { render, staticRenderFns } from "./ProjectInfoProperty.vue?vue&type=template&id=3b613708&"
import script from "./ProjectInfoProperty.vue?vue&type=script&lang=js&"
export * from "./ProjectInfoProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports